import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import styles from "./ProjectDetailPage.module.css";

const DOC_LABEL = {
  datasheet: "Ficha técnica",
  manual: "Manual",
  blueprint: "Plano",
  other: "Documento",
};

export default function ProjectDetailPage() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, "projects", id));
        if (snap.exists()) setProject({ id: snap.id, ...snap.data() });
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return (
      <main style={{ padding: "6rem var(--page-px)" }}>
        <p className="mono-tag">↳ cargando proyecto…</p>
      </main>
    );
  }

  if (!project) {
    return (
      <main style={{ padding: "6rem var(--page-px)" }}>
        <p className="mono-tag">// 404 — proyecto no encontrado</p>
        <Link to="/proyectos" className={styles.back}>
          ← volver al repositorio
        </Link>
      </main>
    );
  }

  return (
    <main className={styles.wrap}>
      <Link to="/proyectos" className={styles.back}>
        ← repositorio
      </Link>

      <header className={styles.head}>
        <span className="mono-tag">// proyecto · {project.id.slice(0, 6).toUpperCase()}</span>
        <h1 className={styles.h1}>{project.name}</h1>
        {project.shortDescription && (
          <p className={styles.lead}>{project.shortDescription}</p>
        )}
      </header>

      {project.heroImage?.url && (
        <figure className={styles.hero}>
          <img src={project.heroImage.url} alt={project.name} />
        </figure>
      )}

      <div className={styles.body}>
        {project.longDescription && (
          <article className={styles.long}>
            <h2 className={styles.h2}>Descripción</h2>
            <p>{project.longDescription}</p>
          </article>
        )}

        <aside className={styles.docs}>
          <h2 className={styles.h2}>Documentos</h2>
          {(project.docs || []).length === 0 ? (
            <p className={styles.empty}>// sin documentos asociados</p>
          ) : (
            <ul>
              {project.docs.map((d, i) => (
                <li key={i} className={styles.docRow}>
                  <div>
                    <span className="mono-tag">
                      {DOC_LABEL[d.type] || "Documento"}
                    </span>
                    <p className={styles.docLabel}>{d.label}</p>
                  </div>
                  <a
                    className={styles.dlink}
                    href={d.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Descargar ↗
                  </a>
                </li>
              ))}
            </ul>
          )}
        </aside>
      </div>

      {(project.gallery || []).length > 0 && (
        <section className={styles.gallery}>
          <h2 className={styles.h2}>Galería</h2>
          <div className={styles.galGrid}>
            {project.gallery.map((g, i) => (
              <figure key={i}>
                <img src={g.url} alt={g.alt || project.name} />
              </figure>
            ))}
          </div>
        </section>
      )}
    </main>
  );
}
